import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
export interface CustomerDashboardSummary {
  totalEquipments?: number;
  service?: number; //this is cost which spent by customer on service in dollars
  parts?: number; //this is cost which spent by customer on parts in dollars
  equipments?: number; //this is cost which spent by customer on equipments in dollars
}
export interface GetAnalyticsRequest {
  fromDate: string;
  toDate: string;
  setupId?: string;
}
export interface DealerDashboardSummary {
  unreadOrders: number;
  unreadQuotes: number;
}
export interface DashboardState {
  customerDashboard?: CustomerDashboardSummary;
  dealerDashboard?: DealerDashboardSummary;
}
export const DashboardApi = createApi({
  reducerPath: "DashboardApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    getDealerDmsSetupStats: build.query<any, { dealerId: string }>({
      query: () => ({
        url: `api/DmsSetup/GetDmsSetupStats`,
        method: "get",
      }),
    }),
    getBestSellingProducts: build.mutation<
      any,
      { request: GetAnalyticsRequest }
    >({
      query: ({ request }) => ({
        url: `api/Order/GetBestSellingProducts`,
        method: "post",
        data: request,
      }),
    }),
    GetOrderAnalytics: build.mutation<any, { request: GetAnalyticsRequest }>({
      query: ({ request }) => ({
        url: `api/Order/GetOrderAnalytics`,
        method: "post",
        data: request,
      }),
    }),
    GetUnreadOrdersAndQuotesCount: build.mutation<any, void>({
      query: () => ({
        url: `api/DmsSetup/GetUnreadOrdersAndQuotesCount`,
        method: "post",
        data: null,
      }),
    }),
    GetCustCategoryAndPayMethod: build.query<any, void>({
      query: () => ({
        url: `api/AppHealth/GetCustCategoryAndPayMethodStatus`,
        method: "get",
      }),
    }),
    GetStoreUrlAndAccessToken: build.query<any, void>({
      query: () => ({
        url: `api/AppHealth/GetStoreUrlAndAccessTokenStatus`,
        method: "get",
      }),
    }),
    GetStoreWebhook: build.query<any, void>({
      query: () => ({
        url: `api/AppHealth/GetStoreWebhookStatus`,
        method: "get",
      }),
    }),
    GetPaymentSettings: build.query<any, void>({
      query: () => ({
        url: `api/AppHealth/GetPaymentSettingsStatus`,
        method: "get",
      }),
    }),
  }),
});
const initialState: DashboardState = {};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    addCustomerDashboardCounts: (state, action: PayloadAction<any>) => {
      state.customerDashboard = action.payload.customerDashboard;
    },
    addDealerDashboardCounts: (
      state,
      action: PayloadAction<DealerDashboardSummary>
    ) => {
      state.dealerDashboard = action.payload;
    },
    removeCustomerDashboardCounts: (state) => {
      state.customerDashboard = undefined;
    },
    incrementUnreadOrders: (state, action: PayloadAction<number>) => {
      if (!state.dealerDashboard) {
        state.dealerDashboard = { unreadOrders: 0, unreadQuotes: 0 };
      }
      state.dealerDashboard.unreadOrders += action.payload;
    },
    incrementUnreadQuotes: (state, action: PayloadAction<number>) => {
      if (!state.dealerDashboard) {
        state.dealerDashboard = { unreadOrders: 0, unreadQuotes: 0 };
      }
      state.dealerDashboard.unreadQuotes += action.payload;
    },
  },
});
export const {
  addCustomerDashboardCounts,
  addDealerDashboardCounts,
  removeCustomerDashboardCounts,
  incrementUnreadOrders,
  incrementUnreadQuotes,
} = dashboardSlice.actions;

export const {
  useGetDealerDmsSetupStatsQuery,
  useGetOrderAnalyticsMutation,
  useGetBestSellingProductsMutation,
  useGetUnreadOrdersAndQuotesCountMutation,
  useGetCustCategoryAndPayMethodQuery,
  useGetStoreUrlAndAccessTokenQuery,
  useGetStoreWebhookQuery,
  useGetPaymentSettingsQuery,
} = DashboardApi;
export const dashboardReducer = dashboardSlice.reducer;
